import { useQuery } from '@apollo/client';

import { EntityPagesArticleModuleListDocument } from '../../graphql/queries/articles-list.gql-types';
import type { EntityPagesArticleModuleListQueryVariables } from '../../graphql/queries/articles-list.gql-types';
import { createArticleCards } from '../../models/article-card';

export const useArticleCards = (
  variables: EntityPagesArticleModuleListQueryVariables
) => {
  const { data, loading, error, refetch, fetchMore } = useQuery(
    EntityPagesArticleModuleListDocument,
    { variables }
  );

  const articlesEdges = data?.contentPageArticles?.edges;
  const articlesNodes =
    articlesEdges
      ?.map((edge) => edge?.node)
      .filter((node) => node !== undefined) ?? [];
  const articlesCards = createArticleCards(articlesNodes);

  const handleFetchMore = () => {
    return new Promise((resolve) => {
      fetchMore({
        variables: {
          after: data?.contentPageArticles?.pageInfo.endCursor,
        },
        updateQuery: (prev: any, { fetchMoreResult }) => {
          resolve(true);
          if (!fetchMoreResult) return prev;
          return {
            contentPageArticles: {
              ...fetchMoreResult.contentPageArticles,
              edges: [
                ...(prev?.contentPageArticles?.edges ?? []),
                ...(fetchMoreResult?.contentPageArticles?.edges ?? []),
              ],
            },
          };
        },
      });
    });
  };

  // TODO: update this any once the query has All types
  const handleRefetch = (newStatus: any) => {
    return refetch({
      pageUrn: variables.pageUrn,
      status: newStatus,
    });
  };

  return {
    articlesCards,
    hasFeaturedArticle: articlesCards.some((article) => article.isFeatured),
    hasNextPage: !!data?.contentPageArticles?.pageInfo.hasNextPage,
    endCursor: data?.contentPageArticles?.pageInfo.endCursor,
    loading,
    error,
    refetch: handleRefetch,
    fetchMore: handleFetchMore,
  };
};
